<script setup lang="ts">
import { DownloadOutlined } from '@ant-design/icons-vue'
import {
  cancelExportConfirm,
  confirmExportConfirm,
  exportConfirmUi,
} from '@/composables/useExportConfirm'

defineOptions({ name: 'ExportConfirmModal' })

function onCancel() {
  cancelExportConfirm()
}

function onOpenChange(open: boolean) {
  if (!open) onCancel()
}

function onConfirm() {
  void confirmExportConfirm()
}
</script>

<template>
  <a-modal
    :open="exportConfirmUi.open"
    width="520px"
    centered
    :footer="null"
    :mask-closable="!exportConfirmUi.submitting"
    :keyboard="!exportConfirmUi.submitting"
    :closable="!exportConfirmUi.submitting"
    destroy-on-close
    wrap-class-name="export-confirm-wrap"
    @update:open="onOpenChange"
    @cancel="onCancel"
  >
    <template #title>
      <div class="ex-head">
        <span class="ex-head__icon">
          <DownloadOutlined />
        </span>
        <div>
          <div class="ex-head__title">{{ exportConfirmUi.title }}</div>
          <div class="ex-head__sub">按当前筛选生成文件并下载到本地</div>
        </div>
      </div>
    </template>
    <div class="ex-body">
      <div class="ex-card">
        <p class="ex-card__name">{{ exportConfirmUi.label }}</p>
        <p class="ex-card__meta">{{ exportConfirmUi.meta }}</p>
      </div>
      <p v-if="exportConfirmUi.extra" class="ex-hint">{{ exportConfirmUi.extra }}</p>
      <p v-if="exportConfirmUi.limitHint" class="ex-hint is-warn">
        {{ exportConfirmUi.limitHint }}
      </p>
      <p v-else-if="!exportConfirmUi.extra" class="ex-hint">确认后立即生成文件并下载到本地。</p>
      <div v-if="exportConfirmUi.checkboxLabel" class="ex-check">
        <a-checkbox v-model:checked="exportConfirmUi.checked">
          {{ exportConfirmUi.checkboxLabel }}
        </a-checkbox>
      </div>
      <div class="ex-foot">
        <a-button :disabled="exportConfirmUi.submitting" @click="onCancel">取消</a-button>
        <a-button type="primary" :loading="exportConfirmUi.submitting" @click="onConfirm">
          {{ exportConfirmUi.okText }}
        </a-button>
      </div>
    </div>
  </a-modal>
</template>

<style scoped>
.ex-head {
  display: flex;
  align-items: center;
  gap: 12px;
  padding-right: 48px;
}

.ex-head__icon {
  display: inline-flex;
  width: 40px;
  height: 40px;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  border-radius: 12px;
  color: #fff;
  font-size: 18px;
  background: linear-gradient(160deg, #38bdf8, #2563eb);
  box-shadow: 0 8px 16px rgba(37, 99, 235, 0.22);
}

.ex-head__title {
  font-size: 16px;
  font-weight: 650;
  color: #0f172a;
}

.ex-head__sub {
  margin-top: 2px;
  font-size: 12px;
  color: #94a3b8;
}

.ex-body {
  padding: 4px 2px 2px;
}

.ex-card {
  padding: 16px;
  border-radius: 14px;
  border: 1px solid #e8eef5;
  background: linear-gradient(180deg, #f8fafc 0%, #fff 100%);
}

.ex-card__name {
  margin: 0;
  font-size: 16px;
  font-weight: 650;
  line-height: 1.4;
  color: #0f172a;
  word-break: break-word;
}

.ex-card__meta {
  margin: 8px 0 0;
  font-size: 13px;
  color: #64748b;
}

.ex-hint {
  margin: 14px 0 0;
  padding: 10px 12px;
  border-radius: 10px;
  font-size: 13px;
  line-height: 1.6;
  background: #eff6ff;
  color: #1d4ed8;
}

.ex-hint.is-warn {
  background: #fff7ed;
  color: #c2410c;
}

.ex-check {
  margin-top: 12px;
}

.ex-foot {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 16px;
}
</style>

<style>
.export-confirm-wrap .ant-modal-content {
  border-radius: 18px;
  overflow: hidden;
  box-shadow: 0 24px 64px rgba(15, 23, 42, 0.16);
}

.export-confirm-wrap .ant-modal-header {
  margin: 0;
  padding: 18px 24px 8px;
  border-bottom: 0;
}

.export-confirm-wrap .ant-modal-body {
  padding: 8px 24px 20px;
}

.export-confirm-wrap .ant-modal-close {
  top: 16px;
  inset-inline-end: 16px;
}
</style>
